export default "__VITE_ASSET__CyxKfmC9__"